import { defineStore } from 'pinia'

const useFinancialStore = defineStore('financial', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useFinancialStore
